import React, { useEffect, useState } from "react";
import { flattenData } from "../../../../Utilitie";
import GroupedBarChart from "../../../../CHARTS/GroupedBarChart";
import GroupedStackedBarChart from "../../../../CHARTS/GroupedStackedBarChart";
const GraphFromSummeryData = ({ data }) => {
  const [monthWiseCD, setMonthWiseCD] = useState(null);
  const [shiftWise, setShiftWiseCD] = useState(null);
  const [directionWiseCD, setDirectionWisCD] = useState(null);
  const tempData = flattenData(data);
  useEffect(() => {
    if (!data) {
      return;
    }
    let cd = { dimensions: [], series: [] };
    const years = [...new Set(tempData.map((o) => o.F_YEAR))].sort(
      (a, b) => a.replace("_", "") - b.replace("_", "")
    );
    const months = [...new Set(tempData.map((o) => o.A_MONTH))];
    const shift = [...new Set(tempData.map((o) => o.SHIFT))];
    const direction = [...new Set(tempData.map((o) => o.UP_DOWN))];
    let shiftCD = { dimensions: [], series: [] };
    let directionCD = { dimensions: [], series: [] };
    cd = {
      ...cd,
      dimensions: ["product", ...years],
    };
    shiftCD = {
      ...shiftCD,
      dimensions: ["product", ...years],
    };
    directionCD = {
      ...directionCD,
      dimensions: ["product", ...years],
    };
    let tempSeries = months.map((m) => {
      return { product: m };
    });
    let tempShiftSeries = shift.map((s) => {
      return { product: s };
    });
    let tempDirectionSeries = direction.map((d) => {
      return { product: d };
    });
    //////////////////////TEMP MONTH WISE//////////////////////////////////
    tempSeries.forEach((obj) => {
      years.map((y) =>
        months.map((m) => {
          let af = tempData.filter(
            (td) => td.F_YEAR === y && td.A_MONTH === m
          ).length;

          if (obj.product === m) {
            return (obj[y] = af);
          }
        })
      );
    });
    cd.series = tempSeries;
    /////////////////////TEMP SERIES WISE////////////////////////
    tempShiftSeries.forEach((obj) => {
      years.map((y) =>
        shift.map((m) => {
          let af = tempData.filter(
            (td) => td.F_YEAR === y && m === td.SHIFT
          ).length;

          if (obj.product === m) {
            return (obj[y] = af);
          }
        })
      );
    });
    shiftCD.series = tempShiftSeries;
    /////////////////////DIRECTION WISE///////////////////////////
    tempDirectionSeries.forEach((obj) => {
      years.map((y) =>
        direction.map((m) => {
          let af = tempData.filter(
            (td) => td.F_YEAR === y && m === td.UP_DOWN
          ).length;

          if (obj.product === m) {
            return (obj[y] = af);
          }
        })
      );
    });
    directionCD.series = tempDirectionSeries;
    setMonthWiseCD(cd);
    setShiftWiseCD(shiftCD);
    setDirectionWisCD(directionCD);
  }, [data]);
  // console.log(shiftWise);
  return (
    <div>
      {/* {console.log(monthWiseCD && Object.keys(monthWiseCD).length)} */}
      <div className="row">
        <div className="col-md-6 ">
          <div className="papaDiv " style={{ background: "rgba(0,0,0,0)" }}>
            <div className="text-white bg-dark p-1 ">
              <h5> Month wise </h5>
            </div>
            {monthWiseCD && Object.keys(monthWiseCD).length > 0 && (
              <GroupedBarChart
                data={monthWiseCD}
                from="AssetFailure"
                rotateText={1}
                chartType={"bar"}
              />
            )}
          </div>
        </div>
        <div className="col-md-3 ">
          <div className="papaDiv" style={{ background: "rgba(0,0,0,0)" }}>
            <div className="text-white bg-dark p-1 ">
              <h5> Shift wise </h5>
            </div>
            {shiftWise && Object.keys(shiftWise).length > 0 && (
              <GroupedBarChart
                data={shiftWise}
                from="AssetFailure"
                rotateText={1}
                chartType={"bar"}
              />
            )}
          </div>
        </div>
        <div className="col-md-3 ">
          <div className="papaDiv" style={{ background: "rgba(0,0,0,0)" }}>
            <div className="text-white bg-dark p-1 ">
              <h5> Direction wise </h5>
            </div>
            {directionWiseCD && Object.keys(directionWiseCD).length > 0 && (
              <GroupedBarChart
                data={directionWiseCD}
                from="AssetFailure"
                rotateText={1}
                chartType={"bar"}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
export default GraphFromSummeryData;
